"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var EyeStrike = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m17.239 18.653 3.054 3.054 1.414-1.414-18-18-1.414 1.414 2.778 2.778c-.535.43-1.01.884-1.429 1.335a15.386 15.386 0 0 0-1.923 2.575 13.438 13.438 0 0 0-.591 1.107l-.033.072-.01.02-.002.008-.001.002v.001L.911 12l.169.394v.002l.002.002.003.007.01.021.032.072a13.438 13.438 0 0 0 .591 1.107 15.387 15.387 0 0 0 1.923 2.575C5.385 18.057 8.132 20 12 20c2.058 0 3.798-.55 5.239-1.347zm-1.485-1.485-.996-.996a5 5 0 0 1-6.929-6.929L6.494 7.909c-.519.4-.98.833-1.387 1.271A13.388 13.388 0 0 0 3.112 12a13.388 13.388 0 0 0 1.996 2.82C6.615 16.442 8.868 18 12 18c1.43 0 2.677-.325 3.754-.832zm-6.462-6.461a3 3 0 0 0 4.001 4.001l-4-4.001zm-8.211 1.687.118-.05.8-.343-.918.393zM2 12l-.92-.395L2 12z", fill: fill || 'currentColor' }),
        React.createElement("path", { d: "M22.281 13.605a15.39 15.39 0 0 1-1.892 2.542l-1.415-1.416A13.424 13.424 0 0 0 20.888 12a13.392 13.392 0 0 0-1.996-2.82C17.385 7.557 15.132 6 12 6c-.566 0-1.104.05-1.613.144L8.738 4.495A10.79 10.79 0 0 1 12 4c3.868 0 6.615 1.943 8.358 3.82a15.384 15.384 0 0 1 1.923 2.575 13.415 13.415 0 0 1 .591 1.107l.033.072.01.02.002.008.002.003L22 12l.919.395-.002.003-.003.007-.009.021a9.013 9.013 0 0 1-.153.322c-.105.21-.262.506-.47.857z", fill: fill || 'currentColor' }),
        React.createElement("path", { d: "M22.919 12.395 22 12c.92-.394.919-.394.919-.395l.169.395-.17.395zm-5.969.313a5 5 0 0 0-5.658-5.658l5.658 5.658z", fill: fill || 'currentColor' })));
};
exports.default = EyeStrike;
